import { ChangeDetectionStrategy, Component, input, signal, ViewEncapsulation } from '@angular/core';
import { ITooltipBlock } from './tooltip.model';

@Component({
    selector: 's1-tooltip',
    imports: [],
    templateUrl: './tooltip.component.html',
    styleUrl: './tooltip.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'relative inline-block w-10 h-10 border-2 solid flex justify-center items-center rounded-full',
    }
})
export class TooltipComponent {
    readonly id = `tooltip-${TooltipComponent.nextId++}`;
    static nextId = 0;
    block = input.required<ITooltipBlock>();
    showTooltip = signal(false);
}
